import * as React from 'react';
import { DropdownView } from 'src/core/ui/dropdown.view';

interface Props {
	required?: boolean;
	label?: string;
	mode: ControlMode;
	value: number;
	onChange: (newValue: number) => void;
}

export const PriceRoundingTypeEditor: React.SFC<Props> = ({ required, label, mode, value, onChange }): JSX.Element => {
	let dropdownLabel = label;
	if (label === undefined) {
		dropdownLabel = 'Price Rounding Type';
	}

	const options = [
		{ value: 0, label: 'Round Up' },
		{ value: 1, label: 'Round Down' },
		{ value: 2, label: 'Exact Value' }
	];

	return (
		<DropdownView
			required={required}
			label={dropdownLabel}
			model={value}
			disabled={mode === 'display'}
			onChanged={(item) => {
				if (item != null) {
					onChange(item.value);
				}
			}}
			options={options}
		/>
	);
};



// WEBPACK FOOTER //
// ./src/app/general/market/form/parts/price-rounding-type-editor.tsx